import React from 'react'

export default (props) => (
    <div>
        {props.name}<br/>
        <a href={'tel:'+props.phone}>{props.phone}</a><br/>
        <a href={'mailto:'+props.email}>{props.email}</a>
    </div>
)